import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantInvestmentObjectiveService } from '../../services/wealthlane-customer-services';

const useGetParticipantInvestmentObjective = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantInvestmentObjectiveList = useQuery(
    ['getParticipantInvestmentObjectiveList'],
    async () => {
      return await handleRequest(
        ParticipantInvestmentObjectiveService.getApiCustomerApiAppParticipantInvestmentObjectiveParticipantInvestmentObjectivesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantInvestmentObjectiveList;
};
export default useGetParticipantInvestmentObjective;
